import { customElement, query } from 'lit/decorators.js'
import { CSSResultGroup, html, LitElement } from 'lit'
import { style } from './dropdown-menu.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'


@customElement('cse-dropdown-menu')
export class CSEDropdownMenu extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @query('slot')
  private defaultSlot!: HTMLSlotElement

  private allowedChildNodes = [
    'CSE-OPTION',
    'CSE-DROPDOWN-MENU-GROUP'
  ]

  private handleKeyDown = async (event: KeyboardEvent) => {
    const assignedNodesDefault = this.defaultSlot.assignedNodes({ flatten: true })
    const filteredListNodes = assignedNodesDefault.filter(node => this.allowedChildNodes.includes(node.nodeName) )
    const activeElement = document.activeElement as HTMLElement
    const activeIndex = filteredListNodes.findIndex((node) => node === activeElement)
    const activeNode = filteredListNodes[activeIndex]

    switch (event.key) {
      case 'ArrowDown': {
        event.preventDefault()
        const nextIndex = (activeIndex + 1) % filteredListNodes.length
        const nextNode = filteredListNodes[nextIndex]
        if (activeNode instanceof HTMLElement && nextNode instanceof HTMLElement) {
          activeNode.blur()
          nextNode.focus()
        }
        break
      }

      case 'ArrowUp': {
        event.preventDefault()
        const prevIndex = (activeIndex - 1 + filteredListNodes.length) % filteredListNodes.length
        const prevNode = filteredListNodes[prevIndex]
        if (activeNode instanceof HTMLElement && prevNode instanceof HTMLElement) {
          activeNode.blur()
          prevNode.focus()
        }
        break
      }
    }
  }

  override render() {
    return html`
      <div class="cse-dropdown-menu" @keydown=${this.handleKeyDown}>
        <slot class="menu"></slot>
      </div>
    `
  }
}


declare global {
  interface HTMLElementTagNameMap {
    'cse-dropdown-menu': CSEDropdownMenu
  }
}
